import { useTranslation } from 'react-i18next'
import omit from 'lodash-es/omit'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { ROUTE_PATH_LIST_RENTAL_PORTAL } from '../../../../constants/route'
import {
  EntityProfileHeader,
  EntityProfileHeaderTitleWithStatus,
} from '../../../Entity'
import { ICON_COLOR, ICON_HEIGHT_16, IconWithTooltip } from '../../../Icon'
import {
  MultipleViewTypeListActiveItemPreviewHeaderActions,
  MultipleViewTypeListActiveItemPreviewHeaderToggle,
} from '../../../MultipleViewTypeList'
import {
  APPLICANT_NEW_BADGE_TEXT_COLOR,
  getIsRentalPortalApplicantIdentityMasked,
  getIsRentalPortalApplicantNew,
} from '../../../RentalPortalApplicant'
import { Status, STATUS_SIZE_16 } from '../../../Status'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'
import { getApplicantProfileTitle } from '../RentalPortalApplicantProfile.utils'
import { RentalPortalApplicantProfileHeaderContent } from '../RentalPortalApplicantProfileHeaderContent'
import { RentalPortalApplicantProfileHeaderFooter } from '../RentalPortalApplicantProfileHeaderFooter'
import { RentalPortalApplicantProfileHeaderInfoItems } from '../RentalPortalApplicantProfileHeaderInfoItems'
import { RentalPortalApplicantProfileHeaderStageSelect } from '../RentalPortalApplicantProfileHeaderStageSelect'

import { QA_NAME_APPLICANT_PROFILE_HEADER_NEW_BADGE } from './RentalPortalApplicantProfileHeader.constants'
import { getApplicantProfileHeaderAvatarProps } from './RentalPortalApplicantProfileHeader.utils'

import * as styles from './RentalPortalApplicantProfileHeader.module.css'

import LockIcon from '../../../../icons/lock.svg'

function RentalPortalApplicantProfileHeader({
  isPreview,
  openFullPageActionsProps,
}) {
  const { t } = useTranslation()

  const { applicantData, isInitiated, noteEdit } = useApplicantProfileContext()

  const {
    editContainerRef,
    editValue,
    handleChangeEditValue,
    handleSaveEditValue,
    handleStartEditing,
    isEditing,
    isSaving,
  } = noteEdit

  return (
    <EntityProfileHeader
      Content={RentalPortalApplicantProfileHeaderContent}
      Footer={isPreview ? null : RentalPortalApplicantProfileHeaderFooter}
      Header={EntityProfileHeaderTitleWithStatus}
      InfoItems={RentalPortalApplicantProfileHeaderInfoItems}
      contentProps={{
        editContainerRef,
        editValue,
        isEditing,
        isSaving,
        onChangeEditValue: handleChangeEditValue,
        onSaveEditValue: handleSaveEditValue,
        onStartEditing: handleStartEditing,
      }}
      headerProps={{
        ...(isPreview
          ? {
              BackButton: null,
              ToggleButton: MultipleViewTypeListActiveItemPreviewHeaderToggle,
              toggleButtonProps: {
                onClosePreview: openFullPageActionsProps?.onClosePreview,
              },
            }
          : null),
        ...(openFullPageActionsProps
          ? {
              Actions: MultipleViewTypeListActiveItemPreviewHeaderActions,
              actionsProps: {
                ...omit(openFullPageActionsProps, 'onClosePreview'),
                Actions: null,
              },
            }
          : null),
        Status: RentalPortalApplicantProfileHeaderStageSelect,
        entityAvatarProps: getApplicantProfileHeaderAvatarProps({
          applicantData,
          t,
        }),
        sectionBackUrl: `/${ROUTE_PATH_LIST_RENTAL_PORTAL.root}/${ROUTE_PATH_LIST_RENTAL_PORTAL.applicants}`,
        statusProps: { className: styles.stageSelect },
        text: getApplicantProfileTitle({ applicantData, t }),
        textProps: {
          additionalIcons: (
            <>
              {getIsRentalPortalApplicantNew(applicantData) ? (
                <Status
                  className={styles.newBadge}
                  height={STATUS_SIZE_16}
                  qaName={QA_NAME_APPLICANT_PROFILE_HEADER_NEW_BADGE}
                  text={t('RentalPortal.ApplicantBadgeNewKey')}
                  textColor={APPLICANT_NEW_BADGE_TEXT_COLOR}
                />
              ) : null}
              {getIsRentalPortalApplicantIdentityMasked(applicantData) ? (
                <IconWithTooltip
                  Icon={LockIcon}
                  color={ICON_COLOR.SecondaryTextColor}
                  size={ICON_HEIGHT_16}
                  tooltip={t('RentalPortal.ApplicantIdentityMaskedTooltipKey')}
                  tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
                />
              ) : null}
            </>
          ),
          editable: false,
        },
      }}
      isLoading={!isInitiated}
    />
  )
}

export default RentalPortalApplicantProfileHeader
